import { gql } from 'urql';

export const PORTAL_LOGIN = gql`
  mutation PortalLogin($email: String!, $password: String!) {
    portalLogin(email: $email, password: $password) {
      token
      userId
      clienteId
      nombre
      scopes
    }
  }
`;

export const PORTAL_MIS_ENVIOS = gql`
  query PortalMisEnvios($clienteId: ID!, $search: String, $estado: String, $fechaDesde: String, $fechaHasta: String) {
    portalMisEnvios(
      clienteId: $clienteId
      search: $search
      estado: $estado
      fechaDesde: $fechaDesde
      fechaHasta: $fechaHasta
    ) {
      referenciaTipo
      referenciaId
      ultimoEstado
      ultimoDetalle
      ultimoEventoEn
      eventos {
        id
        estado
        detalle
        fechaHora
        fuente
      }
    }
  }
`;

export const PORTAL_MIS_TICKETS = gql`
  query PortalMisTickets($clienteId: ID!, $pagination: PaginationInput, $estado: TicketEstado, $search: String) {
    portalMisTickets(clienteId: $clienteId, pagination: $pagination, estado: $estado, search: $search) {
      items {
        id
        asunto
        estado
        prioridad
        creadoEn
        sla {
          slaNombre
          mttaMin
          mttrMin
          cumplido
        }
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const PORTAL_TICKET = gql`
  query PortalTicket($clienteId: ID!, $id: ID!) {
    portalTicket(clienteId: $clienteId, id: $id) {
      ticket {
        id
        asunto
        descripcion
        estado
        prioridad
        creadoEn
        comentarios {
          id
          autorTipo
          mensaje
          creadoEn
          privado
        }
        adjuntos {
          id
          nombre
          url
        }
      }
      puedeComentar
    }
  }
`;

export const PORTAL_CREAR_TICKET = gql`
  mutation PortalCrearTicket($input: CrearTicketInput!) {
    portalCrearTicket(input: $input) {
      id
    }
  }
`;

export const PORTAL_AGREGAR_COMENTARIO = gql`
  mutation PortalAgregarComentario($input: ComentarioInput!) {
    portalAgregarComentario(input: $input) {
      id
      mensaje
      autorTipo
      creadoEn
    }
  }
`;
